export enum ESurveilancesType {
	constantes = "constantes",
	injections = "injections"
}